import HttpClient from '../httpClient';

export interface Organization {
  id: string;
  name: string;
  logo: string;
  orgUuid: string;
  customerId?: string;
  isSalesDashboardAccessOrg?: boolean;
}

class OrganizationController extends HttpClient {
  getOrganizationsByEmail = async (email: string) => {
    const response = await this.client.get('/public/organizations', {
      params: {
        email,
      },
    });
    return response.data.data?.organizations as Organization[];
  };
}

export default new OrganizationController(
  process.env.REACT_APP_API_URL_ENTERPRISE,
);
